import type { Message } from './message';
import type { Server } from './server';
import type { User } from '@/models/user.ts';
import type { DirectMessage } from '@/models/direct-message.ts';
import type { Conversation } from '@/models/conversation.ts';

export enum MemberRole {
  ADMIN = 'ADMIN',
  MODERATOR = 'MODERATOR',
  PRIVATE = 'PRIVATE',
  GUEST = 'GUEST',
}

export interface Member {
  id: string;
  role: MemberRole;
  profileId: string;
  profile: User;
  serverId: string;
  server: Server;
  messages: Message[];
  directMessages: DirectMessage[];
  conversationsInitiated: Conversation[];
  conversationsReceived: Conversation[];
  createdAt: Date;
  updatedAt: Date;
}
